function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function () {
  'use strict';

  var id = 'heatmap';
  angular.module('wsLrs.cards').factory(id + '.AdvancedColors', ['ChartUtils', 'ListUtils', 'Logger', 'wsColors', function (ChartUtils, ListUtils, Logger, wsColors) {
    var LinkedLists = ListUtils.LinkedLists,
      ALists = ListUtils.ALists;

    /**
     * Advanced Colors
     *
     * This package provides a dsl for describing the 'colorAxis' of a Highcharts Heatmap.
     * It provides two methods: the 'getColorAxis' method, which prepares a `colorAxis` for a given report
     * config; and the 'configuredForAdvancedColorStops' predicate:
     *
     * getColorAxis: HeatmapConfig -> HC-Color-Axis
     *
     * where 'HC-Color-Axis' is just a label used here for convenience:
     *
     * HC-Color-Axis: [HC-Color-Stop]
     *              | [HC-Color-Class]
     * todo         | [HC-Color-Stop|HC-Color-Class]
     * HC-Color-Stop: [[Number, String]]
     * HC-Color-Class: [[Number, Number, String]]
     *
     * The Color-Axis the core of the dsl; it maps directly to the 'colorAxis' property of a Highcharts heatmap.
     * A Color-Axis is essentially an array of Color-Stops or Color-Classes.
     *
     * A Color-Stop is a number in the range [0, 1] together with an rgb hex string that represents the color's
     * position in a gradient.  A Color-Class is pair of numbers together with an rgb hex string that maps a
     * color to a range of values.
     *
     * Syntax:
     * An Advanced Colors DSL Expression may take one of two forms. A simple expression consists of an
     * operator (e.g. 'color-stop'), followed by pairs of parameter names and values.  The second form
     * consists of two expressions joined by a ';'.
     *
     * Expr: String
     * Expr :: operator (param value)...)
     *      :: Expr;Expr
     *
     * the interpreter below accepts a String of this sort and produces an HC-Color-Axis
     *
     * Semantics:
     *
     * Color Stops
     * A Color-Stop expression evaluates to an HC-Color-Stop.  A sequence of such expressions will evaluate
     * to an HC-Color-Axis.
     *
     * color-stop <position> <n> color <c> tolerance <t>
     * position :: before | at | after
     *
     * note: when 'position' is 'at' the color stop occurs at exactly the given 'n'.
     *  when 'position' is 'before' or 'after' the stop is positioned just a little before or after 'n';
     *  how much is determined by the 'tolerance', 't'.
     *
     * Color Classes
     * A Color-Class expression evaluates to an HC-Color-Class.  A sequence of such expressions will evaluate
     * to an HC-Color-Axis.
     *
     * color-class from <m> to <n> color <c>
     *
     * note: you may omit the 'from' or the 'to' param (but not both)
     *
     *
     * Extensions:
     *
     * Color Blocks
     * A 'color-block' assigns a single color to all values in a given quantile (i.e. a continuous interval
     * of the frequency distribution of the underlying data)
     *
     * color-block <lower-bound> <m> <upper-bound> <n>  color <c> tolerance <t>
     * lower-bound: gt | gte
     * upper-bound: lt | lte
     *
     * note: a color-block expression may omit either the lower or upper bound; in which case, the band will
     *  extend to the minimal (0.0) or maximal (1.0) value.
     *
     *
     * Internals:
     *
     * The heart of the package is the 'interpret' function.  It consumes a string, divides it into simple
     * expressions, creates syntax objects from simple expressions, then evaluates the syntax-objects in order
     * to produce an HC-Color-Axis
     *
     * Stx: {source: String, op: String, params: AList}
     *
     * interpret:       String -> HC-Color-Axis
     *
     * read:            String -> List(Expr)
     * parse:           List(Expr) => List(Stx)
     * evaluate:        List(Stx) -> HC-Color-Axis
     *
     * readExpr:        String -> Expr
     * parseExpr:       Expr -> Stx
     * evaluateSyntax:  Stx -> [HC-Color-Stop]
     *                       | [HC-Color-Class]
     * todo                  | [HC-Color-Stop|HC-Color-Class]
     *
     * makeColorStop:   {orientation: String, position: Number, tolerance: Number?, color: String} -> HC-Color-Stop
     * makeColorStops:  [{orientation: String, position: Number, tolerance: Number?, color: String}] -> [HC-Color-Stop]
     *
     * makeColorClass:      { from: Number, to: Number, color: String } -> HC-Color-Class
     * makeColorClasses:    [{ from: Number, to: Number, color: String }] -> [HC-Color-Class]
     */

    var COLOR_AXIS_DEFAULTS = Object.freeze({
      min: 0,
      max: 100
    });

    /**
     * Get the default array of colors from the report config, if possible, or else use the Watershed colors.
     * @param config
     * @returns {[HC-Color-Stop]}
     */
    function getDefaultColorStops(config) {
      return [[-0.00001, ChartUtils.getSeriesColor(config, 0, wsColors.wsGrayLighter)], [0.0, ChartUtils.getSeriesColor(config, 1, wsColors.wsWhite)], [0.0001, ChartUtils.getSeriesColor(config, 2, wsColors.wsGrayLightest)], [1.0, ChartUtils.getSeriesColor(config, 3, wsColors.wsBlueDarker)]];
    }

    /**
     * Determine whether the report uses Advanced Colors
     * @param config
     * @returns {boolean}
     */
    function configuredForAdvancedColorStops(config) {
      return Array.isArray(config.advancedColors) && config.advancedColors.length > 0;
    }

    /**
     * Get the default color axis for the given report
     * @param config
     * @returns {HC-Color-Axis}
     */
    function getDefaultColorAxis(config) {
      return makeColorStopAxisWithDefaults(getDefaultColorStops(config), COLOR_AXIS_DEFAULTS);
    }

    /**
     * Interpret the given report's Advanced Color expressions
     * @param interpret
     * @param config
     * @returns {HC-Color-Axis|any}
     */
    function makeColorAxis(interpret, config) {
      var _interpret = interpret(config.advancedColors.join(";")),
        axisType = _interpret.axisType,
        axisValues = _interpret.axisValues;
      if (axisType === 'stops') {
        return makeColorStopAxisWithDefaults(axisValues, COLOR_AXIS_DEFAULTS);
      }
      if (axisType === 'classes') {
        return makeColorClassAxisWithDefaults(axisValues, {});
      }
      return getDefaultColorAxis(config);
    }
    function makeColorStopAxisWithDefaults(stops, defaults) {
      return Object.assign({}, defaults, {
        stops: stops
      });
    }
    function makeColorClassAxisWithDefaults(dataClasses, defaults) {
      return Object.assign({}, defaults, {
        dataClasses: dataClasses
      });
    }
    function makeColorStop(_ref) {
      var orientation = _ref.orientation,
        position = _ref.position,
        tolerance = _ref.tolerance,
        color = _ref.color;
      if (orientation === 'before') {
        return [position - 1.0 / tolerance, color];
      }
      if (orientation === 'at') {
        return [position, color];
      }
      if (orientation === 'after') {
        return [position + 1.0 / tolerance, color];
      }
    }
    function makeColorStops() {
      for (var _len = arguments.length, stops = new Array(_len), _key = 0; _key < _len; _key++) {
        stops[_key] = arguments[_key];
      }
      return stops.map(makeColorStop);
    }
    function makeColorClass(_ref2) {
      var from = _ref2.from,
        to = _ref2.to,
        color = _ref2.color;
      return {
        from: from,
        to: to,
        color: color
      };
    }
    function makeColorClasses() {
      for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        classes[_key2] = arguments[_key2];
      }
      return classes.map(makeColorClass);
    }

    /**
     * The 'interpreter_config' contains important constants and methods required to process an 'Advanced
     * Colors' expression into another data structure (in this case a valid Highcharts color axis).  The
     * 'metaProcessors' object contains functions that parse each type of expression and add some information
     * that will be used by an evaluation function that produces a data structure for each expression.  The
     * evaluation functions are contained in the 'caseEvaluators' object.
     */
    var parseColorClassBoundary = function parseColorClassBoundary(s) {
      if (typeof s !== 'string') {
        return undefined;
      }
      if (s.includes('.')) {
        return parseFloat(s);
      }
      return parseInt(s);
    };
    var interpreter_config = {
      // the expressionTerminator is just the sequence of characters used to delimit expressions
      // in the advanced colors dsl
      expressionTerminator: ";",
      // a meta-processor is invoked by the parser to add some meta-data to the syntax-objects it produces
      metaProcessors: {
        "color-stop": function colorStop(stx) {
          var a_location = ALists.find(stx.params, ['before', 'at', 'after'], {
            alt: {
              key: 'at',
              val: 1.0
            }
          });
          var orientation = a_location.key;
          var position = parseFloat(a_location.val);
          var color = ALists.lookup(stx.params, 'color');
          var tolerance = parseInt(ALists.lookup(stx.params, 'tolerance', {
            alt: 10000
          }));
          return {
            a_location: a_location,
            orientation: orientation,
            position: position,
            color: color,
            tolerance: tolerance
          };
        },
        "color-class": function colorClass(stx) {
          var from = parseColorClassBoundary(ALists.lookup(stx.params, 'from'));
          var to = parseColorClassBoundary(ALists.lookup(stx.params, 'to'));
          var color = ALists.lookup(stx.params, 'color');
          return {
            from: from,
            to: to,
            color: color
          };
        },
        "color-block": function colorBlock(stx) {
          var a_lower_bound = ALists.find(stx.params, ['gt', 'gte'], {
            alt: {
              key: 'gte',
              val: 0.0
            }
          });
          var lower_orientation = a_lower_bound.key;
          var lower_position = parseFloat(a_lower_bound.val);
          var a_upper_bound = ALists.find(stx.params, ['lt', 'lte'], {
            alt: {
              key: 'lte',
              val: 1.0
            }
          });
          var upper_orientation = a_upper_bound.key;
          var upper_position = parseFloat(a_upper_bound.val);
          var color = ALists.lookup(stx.params, 'color');
          var tolerance = parseInt(ALists.lookup(stx.params, 'tolerance', {
            alt: 10000
          }));
          return {
            a_lower_bound: a_lower_bound,
            lower_orientation: lower_orientation,
            lower_position: lower_position,
            a_upper_bound: a_upper_bound,
            upper_orientation: upper_orientation,
            upper_position: upper_position,
            color: color,
            tolerance: tolerance
          };
        }
      },
      // a case-evaluator determines the value of a syntax-object, given some meta-data.
      caseEvaluators: {
        "color-stop": function colorStop(stx) {
          stx.value = makeColorStops(stx.metaData);
          return stx;
        },
        "color-class": function colorClass(stx) {
          stx.value = makeColorClasses(stx.metaData);
          return stx;
        },
        "color-block": function colorBlock(stx) {
          var orientation_map = {
            "gt": "after",
            "gte": "at",
            "lt": "before",
            "lte": "at"
          };
          var lower_bound = {
            orientation: orientation_map[stx.metaData.lower_orientation],
            position: stx.metaData.lower_position,
            tolerance: stx.metaData.tolerance,
            color: stx.metaData.color
          };
          var upper_bound = {
            orientation: orientation_map[stx.metaData.upper_orientation],
            position: stx.metaData.upper_position,
            tolerance: stx.metaData.tolerance,
            color: stx.metaData.color
          };
          stx.value = makeColorStops(lower_bound, upper_bound);
          return stx;
        }
      }
    };

    /**
     * Make an interpreter function that will read, parse, and evaluate 'Advanced Colors' expressions.
     * @param interpreter_config
     * @returns {function(String): *}
     */
    function makeInterpreter(interpreter_config) {
      /**
       * todo: annotate method
       * this is core of the advanced colors dsl.
       *
       * @param {String} input
       * @returns an
       */
      function interpret(input) {
        var expressions = read(input);
        var syntax = parse(expressions);
        var result = evaluate(syntax);
        return result;
      }

      /**
       * read an input string as an Expr. the result is a linked-list comprised
       * of the sub-expressions of the given expression.
       *
       * @param {String} str
       * @returns List(Expr)
       */
      function read(str) {
        function readExprs(str) {
          var _readExpr = readExpr(str),
            expr = _readExpr.expr,
            rest = _readExpr.rest;
          if (expr === undefined && rest === undefined) {
            return {};
          }
          if (rest === undefined) {
            return {
              expr: expr
            };
          }
          var next = readExprs(rest);
          return {
            expr: expr,
            next: next
          };
        }
        // todo Get delimiter from interpreter config
        return readExprs(str.trim().replace(/\s+/g, " ").replace(/;+/g, ";"));
      }

      /**
       * reads the first expression from a given string.  the result is an object
       * containing the expression and the remaining string.
       *
       * @param str: String
       * @returns () | (expr: String) | (expr: String, rest: String)
       */
      function readExpr(str) {
        if (str.length === 0) {
          return {};
        }
        var i = str.indexOf(interpreter_config.expressionTerminator);
        var expr = str.slice(0, i < 0 ? str.length : i);
        if (i === -1 || i === str.length - 1) {
          return {
            expr: expr
          };
        }
        var j = str.slice(i + 1).search(/[^\s]/);
        var rest = str.slice(i + 1 + j).trim();
        return {
          expr: expr,
          rest: rest.length === 0 ? undefined : rest
        };
      }

      /**
       * build a list of syntax objects from a list of expressions
       *
       * @param {List(Expr)} exprs
       * @returns
       */
      function parse(exprs) {
        return LinkedLists.map(exprs, function (e) {
          var stx = parseExpr(e);
          stx.metaData = interpreter_config.metaProcessors[stx.op](stx);
          return stx;
        }, {
          a: "expr"
        });
      }

      /**
       * translate a String, expr, into a data structure (SyntaxObject) that will be
       * used to evaluate expr
       *
       * @param {String} expr
       * @returns SyntaxObject
       */
      function parseExpr(expr) {
        var tokens = expr.split(/\s+/);
        return {
          source: expr,
          op: tokens[0],
          params: ALists.array_to_alist(tokens.slice(1))
        };
      }

      /**
       * evaluate a list of syntax objects.  the result is an aray of arrays, where
       * each array element is comprised of a number and string, representing some
       * fraction of the maximum value for the chart (or measure) and the hex-value
       * of a color.  These are Color-Stop definitions.  A HighCharts-Color-Axis is
       * an Array comprised of Color-Stops
       * todo: move description of HC-Color-Axis to top
       *
       * @param {LinkedList(SyntaxObject)} stxObjects
       * @returns
       */
      function evaluate(stxObjects) {
        var values = LinkedLists.map(stxObjects, evaluateStx, {
          a: "expr"
        });
        /*
         * this is where we determine what kind of color axis we will produce
         * todo: enable 'mixed' color axes that contain both stops and classes
         *  this will probably not meet a user's expectations, and the fix may involve separating the
         *  measures into their own series, each with its own color axis
         */
        var updateAxisType = function updateAxisType(op, axisType) {
          // todo: add an 'unrecognized' type as a stuck-state
          var typeIsNone = axisType === 'none';
          var typeIsStops = axisType === 'stops';
          var opIsStopBased = op === 'color-stop' || op === 'color-block';
          if (opIsStopBased && (typeIsNone || typeIsStops)) {
            return 'stops';
          }
          var typeIsClasses = axisType === 'classes';
          var opIsClassBased = op === 'color-class';
          if (opIsClassBased && (typeIsNone || typeIsClasses)) {
            return 'classes';
          }
          return 'none';
        };
        var updateAxisValues = function updateAxisValues(value, axisValues) {
          return [].concat(_toConsumableArray(axisValues), _toConsumableArray(value));
        };
        return LinkedLists.reduce(values, {
          axisType: 'none',
          axisValues: []
        }, function (_ref3, _ref4) {
          var op = _ref3.op,
            value = _ref3.value;
          var axisType = _ref4.axisType,
            axisValues = _ref4.axisValues;
          var newAxisType = updateAxisType(op, axisType);
          if (newAxisType === 'none') {
            return {
              axisType: newAxisType,
              axisValues: []
            };
          }
          return {
            axisType: newAxisType,
            axisValues: updateAxisValues(value, axisValues)
          };
        }, {
          a: 'expr'
        });
      }

      /**
       * evaluate a syntax-object.  the result is an Array of Color-Stops
       *
       * @param {SyntaxObject} stx
       * @returns
       */
      function evaluateStx(stx) {
        return interpreter_config.caseEvaluators[stx.op](stx);
      }
      return interpret;
    }
    var interpret = makeInterpreter(interpreter_config);

    /**
     * 'getColorAxis' is the client application's interface to 'Advanced Colors';  it will evaluate 'Advanced
     * Color' expressions as described above, or provide the default color axis.
     * @param config
     * @returns {HC-Color-Axis}
     */
    function getColorAxis(config) {
      if (configuredForAdvancedColorStops(config)) {
        return makeColorAxis(interpret, config);
      }
      return getDefaultColorAxis(config);
    }
    return Object.freeze({
      configuredForAdvancedColorStops: configuredForAdvancedColorStops,
      getColorAxis: getColorAxis
    });
  }]);
})();
